import { Flex, Typography } from "@p0security/ui";
import { StyledRoutingRuleNamePreview } from "components/Jit/Policy/styles";

type Props = {
  name: string | undefined;
  emptyLabel?: string;
  icon?: React.ReactNode;
  subtitle?: string;
};

export const NamePreview: React.FC<Props> = ({
  name,
  emptyLabel = "(Unnamed rule)",
  icon,
  subtitle,
}) => {
  return (
    <Flex align="center" gap={12}>
      {icon && <Typography.Text>{icon}</Typography.Text>}
      <Flex vertical>
        <StyledRoutingRuleNamePreview>
          {!!name?.trim() ? (
            <span>{name}</span>
          ) : (
            <span className="italic font-normal">{emptyLabel}</span>
          )}
        </StyledRoutingRuleNamePreview>
        {subtitle && (
          <Typography.Text type="secondary" className="text-xs font-normal">
            {subtitle}
          </Typography.Text>
        )}
      </Flex>
    </Flex>
  );
};
